




























import { computed, defineComponent, PropType } from '@nuxtjs/composition-api'
import { isCabinetClickable } from './cabinet'
import { CardsLkItem } from '@/contracts/CardsLk'

export default defineComponent({
  name: 'CabinetHeroCard',
  props: {
    item: {
      type: Object as PropType<CardsLkItem>,
      required: true,
    },
  },
  setup(props) {
    const clickable = computed(() => isCabinetClickable(props.item))
    return { clickable }
  },
})
